// extracted by mini-css-extract-plugin
module.exports = {"recommendation":"D5M3JPuP0DwT5H81iWzkH","feedback":"_1dT6fRuxJepf9vc78ttnf0","accept":"bNKI3wAn0b9JScnCkgvRW","reject":"_1OXRSny2qWqOev5v_NP6UM"};